import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes, Outlet } from 'react-router-dom';
import Home from './pages/Home';
import Event from './pages/Event';
import About from './pages/about';
import Blog from './pages/blog';
import Blogpost from './pages/blogpost';
import Affiliate from './pages/affiliate';
import PrivacyPolicy from './pages/privacy-policy';
import Header from './components/header';
import Footer from './components/footer';
import ScrollToTop from './components/ScrollToTop';
import CountdownBanner from './components/CountdownBanner';
import { LanguageProvider, useLanguage } from './contexts/LanguageContext';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './assets/stolzl/font.css';
import './global.css';
import GTMPageView from './components/gtmpageview.js';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from './firebase/config';
import eplogo from './assets/eplogo.png';
import Relive from './pages/relive';
import SignUpLoyal from './pages/signupsloyal/app/App.tsx';
import LoyalFreaks from './pages/loyal-freaks/app/App.tsx';
import { registerAffiliate } from './services/api.ts';
import Influencer from './pages/influencer';
import ProAffiliate from './pages/pro-affiliate';
import NotFound from './pages/NotFound';
import ContactUs from './pages/ContactUs';

const Layout = () => {
  return (
    <div>
      <CountdownBanner />
      <Header />
      <Outlet />
      <Footer />
    </div>
  );
};
function AppContent() {
  const { isArabic } = useLanguage();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [buttonPosition, setButtonPosition] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false);

  // Affiliate Popup State
  const [isAffiliatePopupOpen, setIsAffiliatePopupOpen] = useState(false);
  const [affiliateName, setAffiliateName] = useState('');
  const [affiliateEmail, setAffiliateEmail] = useState('');
  const [affiliatePhone, setAffiliatePhone] = useState('');
  const [affiliateTos, setAffiliateTos] = useState(false);
  const [isAffiliateSuccess, setIsAffiliateSuccess] = useState(false);
  const [isTosPopupOpen, setIsTosPopupOpen] = useState(false);

  // Helper function to get UTM parameters from sessionStorage
  const getUTM = () => {
    const stored = sessionStorage.getItem('utm_params');
    return stored ? JSON.parse(stored) : {};
  };

  // Helper function to get current page name
  const getPageName = () => {
    const path = window.location.pathname;
    if (path === '/') return 'home';
    if (path === '/about') return 'about';
    if (path === '/blog') return 'blog';
    if (path.startsWith('/blog/')) return 'blog';
    if (path === '/Event') return 'event';
    if (path === '/affiliate') return 'affiliate';
    return path.replace('/', '') || 'home';
  };

  const formatPhoneNumber = (value) => {
    const phoneNumber = value.replace(/\D/g, '');
    // if (phoneNumber.length <= 3) {
    //   return phoneNumber;
    // } else if (phoneNumber.length <= 6) {
    //   return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    // } else {
    //   return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
    // }
    return phoneNumber;
  };

  const handlePhoneChange = (e) => {
    const formatted = formatPhoneNumber(e.target.value);
    setPhone(formatted);
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const cleanPhone = phone.replace(/\D/g, '');

      await addDoc(collection(db, 'signups'), {
        email: email.toLowerCase().trim(),
        phone: cleanPhone,
        createdAt: serverTimestamp(),
      });

      console.log('Successfully saved!');
      const utm = getUTM();

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'action_signup_form_submit',
        'email': email.toLowerCase().trim(),
        'phone': cleanPhone,
        'registration_method': 'popup_form',
        'position': buttonPosition || {
          'page': getPageName(),
          'nav_bar': '',
          'sub_nav_bar': ''
        },
        'referrer_source': document.referrer,
        'utm_source': utm.utm_source || '',
        'utm_medium': utm.utm_medium || '',
        'utm_campaign': utm.utm_campaign || '',
        'utm_term': utm.utm_term || '',
        'utm_content': utm.utm_content || '',
        'gclid': utm.gclid || '',
        'fbclid': utm.fbclid || '',
        'ttclid': utm.ttclid || ''
      });

      setIsSuccess(true);

    } catch (error) {
      console.error('Error saving to Firestore:', error);
      alert('Something went wrong. Please try again.');
    }
  };

  const handleAffiliateSubmit = async (e) => {
    e.preventDefault();

    if (!affiliateTos) {
      alert(isArabic ? 'يرجى الموافقة على الشروط والأحكام' : 'Please agree to the Terms of Service');
      return;
    }

    try {
      const cleanPhone = affiliatePhone.replace(/\D/g, '');

      const result = await registerAffiliate({
        name: affiliateName.trim(),
        email: affiliateEmail.toLowerCase().trim(),
        phone: cleanPhone,
      });
      localStorage.setItem('affiliate_code', result.user.code);
      localStorage.setItem('affiliate_user_id', result.user.id);

      // await addDoc(collection(db, 'signups'), {
      //   name: affiliateName.trim(),
      //   email: affiliateEmail.toLowerCase().trim(),
      //   phone: cleanPhone,
      //   type: 'affiliate', 
      //   createdAt: serverTimestamp(),
      // });

      console.log('Affiliate Signup Successfully saved!');
      const utm = getUTM();

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'action_signup_form_submit',
        'name': affiliateName.trim(),
        'email': affiliateEmail.toLowerCase().trim(),
        'phone': cleanPhone,
        'registration_method': 'affiliate_popup_form',
        'position': buttonPosition || {
          'page': getPageName(),
          'nav_bar': '',
          'sub_nav_bar': ''
        },
        'referrer_source': document.referrer,
        'utm_source': utm.utm_source || '',
        'utm_medium': utm.utm_medium || '',
        'utm_campaign': utm.utm_campaign || '',
        'utm_term': utm.utm_term || '',
        'utm_content': utm.utm_content || '',
        'gclid': utm.gclid || '',
        'fbclid': utm.fbclid || '',
        'ttclid': utm.ttclid || ''
      });

      setIsAffiliateSuccess(true);

    } catch (error) {
      console.error('Error saving to Firestore:', error);
      alert('Something went wrong. Please try again.');
    }
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
    setEmail('');
    setPhone('');
    setButtonPosition(null);
    setIsSuccess(false);
  };

  const handleCloseAffiliatePopup = () => {
    setIsAffiliatePopupOpen(false);
    setAffiliateName('');
    setAffiliateEmail('');
    setAffiliatePhone('');
    setAffiliateTos(false);
    setButtonPosition(null);
    setIsAffiliateSuccess(false);
  };

  // Check for URL parameter to open popup
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const popupParam = searchParams.get('popup');

    if (popupParam === 'signup') {
      // Get UTM parameters
      const utm = getUTM();

      // Get current page name
      const pageName = getPageName();

      // Set position for tracking
      const position = {
        'page': pageName,
        'nav_bar': 'direct_link',
        'sub_nav_bar': ''
      };
      setButtonPosition(position);

      // Track popup open event in GTM
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'screen_view_signup',
        'position': position,
        'referrer_source': document.referrer,
        'utm_source': utm.utm_source || '',
        'utm_medium': utm.utm_medium || '',
        'utm_campaign': utm.utm_campaign || '',
        'utm_term': utm.utm_term || '',
        'utm_content': utm.utm_content || '',
        'gclid': utm.gclid || '',
        'fbclid': utm.fbclid || '',
        'ttclid': utm.ttclid || ''
      });

      // Open the popup
      setIsPopupOpen(true);

      // Clean up URL by removing the parameter
      searchParams.delete('popup');
      const newUrl = window.location.pathname +
        (searchParams.toString() ? '?' + searchParams.toString() : '') +
        window.location.hash;
      window.history.replaceState({}, '', newUrl);
    }
  }, []);

  // Listen for custom event from header to open popup
  useEffect(() => {
    const handleOpenPopup = (event) => {
      const position = event.detail?.position;
      if (position) {
        setButtonPosition(position);
      }
      setIsPopupOpen(true);
    };

    window.addEventListener('openSignupPopup', handleOpenPopup);
    return () => {
      window.removeEventListener('openSignupPopup', handleOpenPopup);
    };
  }, []);

  // Listen for custom event to open affiliate popup
  useEffect(() => {
    const handleOpenAffiliatePopup = (event) => {
      const position = event.detail?.position;
      if (position) {
        setButtonPosition(position);
      }
      setIsAffiliatePopupOpen(true);
    };

    window.addEventListener('openAffiliatePopup', handleOpenAffiliatePopup);
    return () => {
      window.removeEventListener('openAffiliatePopup', handleOpenAffiliatePopup);
    };
  }, []);

  // Handle escape key and body scroll
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isPopupOpen) {
        handleClosePopup();
      }
    };

    if (isPopupOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
      document.body.style.overflowX = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
      document.body.style.overflowX = 'unset';
    };
    document.body.style.overflowX = 'unset';
  }, [isPopupOpen]);

  // Handle escape key for affiliate popup
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isAffiliatePopupOpen) {
        handleCloseAffiliatePopup();
      }
    };

    if (isAffiliatePopupOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
      document.body.style.overflowX = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
      document.body.style.overflowX = 'unset';
    };
  }, [isAffiliatePopupOpen]);

  return (
    <Router>
      <GTMPageView />
      <ScrollToTop />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/Event" element={<Event />} />
          <Route path="/about" element={<About />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blogpost" element={<Navigate to="/blog" replace />} />
          <Route path="/blog/:slug" element={<Blogpost />} />
          <Route path="/affiliate" element={<Affiliate />} />
          <Route path="/relive" element={<Relive />} />
          <Route path="/signups.secret" element={<SignUpLoyal />} />
          <Route path="/returning.secret" element={<LoyalFreaks />} />
          <Route path="/artists" element={<Influencer />} />
          <Route path="/promoters" element={<ProAffiliate />} />
          <Route path="/contact" element={<ContactUs />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>


      {/* Shared Signup Popup Modal */}
      {isPopupOpen && (
        <div
          className="popup-overlay"
          onClick={handleClosePopup}
          onKeyDown={(e) => {
            if (e.key === 'Escape') {
              handleClosePopup();
            }
          }}
          role="dialog"
          aria-modal="true"
          aria-labelledby="popup-title"
        >
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <button
              className="popup-close"
              onClick={handleClosePopup}
              aria-label="Close popup"
            >×</button>
            {!isSuccess ? (
              <>
                <div className="popup-header">
                  <img src={eplogo} alt="Episode Logo" className="popup-logo" />
                  <h2 className="popup-heading">
                    {isArabic ? 'كن أول من يدخل الساحة' : 'Be the First to Enter the Yard'}
                  </h2>
                  <p className="popup-description">
                    {isArabic
                      ? 'سجّل الآن للحصول على وصول مبكر لتذاكر الحلقة 7: FreakYard، وكشف التشكيلة، وتفاصيل المكان، وتحديثات حصرية قبل أي شخص آخر.'
                      : 'Sign up now to get early access to Episode 7: FreakYard tickets, lineup reveals, venue details, and insider updates before anyone else.'}
                  </p>
                </div>
                <form onSubmit={handleSubmit} className="popup-form">
                  <div className="form-group">
                    <label htmlFor="email">{isArabic ? 'البريد الإلكتروني' : 'Email'}</label>
                    <input
                      type="email"
                      id="email"
                      value={email}
                      onChange={handleEmailChange}
                      placeholder={isArabic ? 'بريدك.الإلكتروني@example.com' : 'your.email@example.com'}
                      required
                      className="form-input"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="phone">{isArabic ? 'رقم الهاتف' : 'Phone Number'}</label>
                    <input
                      type="tel"
                      id="phone"
                      value={phone}
                      onChange={handlePhoneChange}
                      placeholder="(966) 456-7890"
                      maxLength="14"
                      required
                      className="form-input"
                    />
                  </div>
                  <button type="submit" className="popup-submit-btn">
                    {isArabic ? 'انضم إلى الحدث القادم' : 'Join Next Event'}
                  </button>
                </form>
              </>
            ) : (
              <>
                <div className="popup-header">
                  <img src={eplogo} alt="Episode Logo" className="popup-logo" />
                  <h2 className="popup-heading" style={{ fontWeight: 'bold' }}>
                    {isArabic ? 'أصبحت FREAK! مرحباً بك في الفريكية' : "You've become a FREAK! Welcome to the freakness"}
                  </h2>
                </div>
                <div className="popup-form">
                  <button type="button" onClick={handleClosePopup} className="popup-submit-btn">
                    {isArabic ? 'إغلاق' : 'Close'}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}

      {/* Affiliate Signup Popup Modal */}
      {isAffiliatePopupOpen && (
        <div
          className="popup-overlay"
          onClick={handleCloseAffiliatePopup}
          onKeyDown={(e) => {
            if (e.key === 'Escape') {
              handleCloseAffiliatePopup();
            }
          }}
          role="dialog"
          aria-modal="true"
          aria-labelledby="affiliate-popup-title"
        >
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <button
              className="popup-close"
              onClick={handleCloseAffiliatePopup}
              aria-label="Close popup"
            >×</button>
            {!isAffiliateSuccess ? (
              <>
                <div className="popup-header affiliate-popup-header" style={{ backgroundColor: '#625DE4', width: 'calc(100% + 80px)', margin: '-40px -40px 30px -40px', padding: '20px', borderRadius: '17px 17px 0 0' }}>
                  {/* <img src={eplogo} alt="Episode Logo" className="popup-logo" /> */}
                  <h2 className="popup-heading" style={{ color: 'white' }}>
                    {isArabic ? 'سجل كمسوق بالعمولة' : 'Sign Up as an Affiliate'}
                  </h2>
                  {/* <p className="popup-description" style={{ color: 'white' }}>
                  {isArabic
                    ? 'انضم إلى برنامج التسويق بالعمولة وابدأ في كسب المكافآت.'
                    : 'Join our affiliate program and start earning rewards.'}
                </p> */}
                </div>
                <form onSubmit={handleAffiliateSubmit} className="popup-form">
                  <div className="form-group">
                    <label htmlFor="affiliateName">{isArabic ? 'الاسم الكامل' : 'Full Name'}</label>
                    <input
                      type="text"
                      id="affiliateName"
                      value={affiliateName}
                      onChange={(e) => setAffiliateName(e.target.value)}
                      placeholder={isArabic ? 'الاسم الكامل' : 'Full Name'}
                      required
                      className="form-input"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="affiliateEmail">{isArabic ? 'البريد الإلكتروني' : 'Email'}</label>
                    <input
                      type="email"
                      id="affiliateEmail"
                      value={affiliateEmail}
                      onChange={(e) => setAffiliateEmail(e.target.value)}
                      placeholder={isArabic ? 'بريدك.الإلكتروني@example.com' : 'your.email@example.com'}
                      required
                      className="form-input"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="affiliatePhone">{isArabic ? 'رقم الهاتف' : 'Phone Number'}</label>
                    <input
                      type="tel"
                      id="affiliatePhone"
                      value={affiliatePhone}
                      onChange={(e) => setAffiliatePhone(formatPhoneNumber(e.target.value))}
                      placeholder="(966) 456-7890"
                      maxLength="14"
                      required
                      className="form-input"
                    />
                  </div>
                  <div className="form-group" style={{ flexDirection: 'row', alignItems: 'center', gap: '10px' }}>
                    <input
                      type="checkbox"
                      id="affiliateTos"
                      checked={affiliateTos}
                      onChange={(e) => setAffiliateTos(e.target.checked)}
                      required
                      style={{ width: '20px', height: '20px', accentColor: '#ED196F' }}
                    />
                    <label htmlFor="affiliateTos" style={{ fontSize: '14px', textTransform: 'none', cursor: 'pointer' }}>
                      {isArabic ? 'أوافق على ' : 'I agree to the '}
                      <span
                        onClick={(e) => {
                          e.preventDefault();
                          setIsTosPopupOpen(true);
                        }}
                        style={{
                          color: '#ED196F',
                          textDecoration: 'underline',
                          cursor: 'pointer',
                          fontWeight: 'bold'
                        }}
                      >
                        {isArabic ? 'الشروط والأحكام' : 'Terms of Service'}
                      </span>
                    </label>
                  </div>

                  <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-start' }}>
                    <button type="submit" className="popup-submit-btn popup-submit-btn-rosa" style={{ backgroundColor: '#ED196F', color: 'white', maxWidth: '200px' }}>
                      {isArabic ? 'سجل الآن' : 'Sign Up'}
                    </button>
                  </div>
                </form>
              </>
            ) : (
              <>
                <div className="popup-header affiliate-popup-header" style={{ backgroundColor: '#625DE4', width: 'calc(100% + 80px)', margin: '-40px -40px 30px -40px', padding: '40px', borderRadius: '17px 17px 0 0' }}>
                  {/* <img src={eplogo} alt="Episode Logo" className="popup-logo" /> */}
                  <h2 className="popup-heading" style={{ fontWeight: 'bold', color: 'white' }}>
                    {isArabic ? 'شكرا لتسجيلك!' : "Thanks for signing up!"}
                  </h2>
                </div>
                <div className="popup-form">
                  <p style={{ textAlign: 'center' }}>
                    {isArabic ? 'سنتواصل معك قريباً.' : 'We have sent you an email with your promo code'}
                  </p>
                  <button type="button" onClick={handleCloseAffiliatePopup} className="popup-submit-btn popup-submit-btn-rosa" style={{ backgroundColor: '#ED196F', color: 'white' }}>
                    {isArabic ? 'إغلاق' : 'Close'}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}

      {/* Terms of Service Popup Modal */}
      {isTosPopupOpen && (
        <div
          className="popup-overlay"
          onClick={() => setIsTosPopupOpen(false)}
          onKeyDown={(e) => {
            if (e.key === 'Escape') {
              setIsTosPopupOpen(false);
            }
          }}
          role="dialog"
          aria-modal="true"
          aria-labelledby="tos-popup-title"
          style={{ zIndex: 10001 }}
        >
          <div className="popup-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '800px', maxHeight: '80vh', overflowY: 'auto' }}>
            <button
              className="popup-close"
              onClick={() => setIsTosPopupOpen(false)}
              aria-label="Close popup"
            >×</button>
            <div className="popup-header" style={{ backgroundColor: '#625DE4', width: 'calc(100% + 80px)', margin: '-40px -40px 30px -40px', padding: '20px', borderRadius: '17px 17px 0 0' }}>
              <h2 className="popup-heading" style={{ color: 'white' }} id="tos-popup-title">
                {isArabic ? 'الشروط والأحكام' : 'AFFILIATE PROGRAM - Terms & Conditions'}
              </h2>
            </div>
            <div style={{ padding: '0 20px 20px 20px', textAlign: 'left' }}>
              <h3 style={{ fontSize: '18px', fontWeight: 'bold', marginTop: '20px' }}>1. Program Overview</h3>
              <p>The Affiliate Program is designed to reward festival enthusiasts for sharing the event and generating organic interest within their communities. As a program participant, you are helping to spread the word while earning rewards.</p>

              <h4 style={{ fontSize: '16px', fontWeight: 'bold', marginTop: '15px' }}>Purpose</h4>
              <p>To incentivize and reward festival fans/artists/influencers for promoting the event through authentic word-of-mouth marketing and social sharing, creating a community-driven approach to festival growth.</p>

              <h3 style={{ fontSize: '18px', fontWeight: 'bold', marginTop: '20px' }}>2. How the Program Works</h3>
              <p>Upon enrollment in the Fans Affiliate Program, you will receive:</p>
              <ol>
                <li>Unique Discount/Referral Code: A personalized coupon code to share with your network</li>
                <li>Unique Referral Link: A trackable URL for sharing across social media and messaging platforms</li>
                <li>Personal Dashboard: Real-time access to track your performance, earned points, and available rewards</li>
              </ol>

              <h3 style={{ fontSize: '18px', fontWeight: 'bold', marginTop: '20px' }}>3. Reward System</h3>
              <h4 style={{ fontSize: '16px', fontWeight: 'bold', marginTop: '15px' }}>Earning Festival Points</h4>
              <p>Ticket Sales: Affiliates earn Festival Points/Rewards for each ticket purchased using their unique referral code or link. Point values per ticket will be communicated in your affiliate dashboard and may vary based on ticket type.</p>

              <h4 style={{ fontSize: '16px', fontWeight: 'bold', marginTop: '15px' }}>Points Allocation</h4>
              <p>The specific point values for each action and tier will be communicated separately and may be adjusted based on campaign requirements. Current points allocation details are available in your affiliate dashboard.</p>

              <h3 style={{ fontSize: '18px', fontWeight: 'bold', marginTop: '20px' }}>4. Collecting Your Rewards</h3>
              <p>Festival Points accumulated through the program are redeemable for:</p>
              <ol start="4">
                <li>Free Festival Tickets: Redeem points for complimentary admission to the festival</li>
                <li>Exclusive On-Site Experiences: Backstage access (subject to availability & to artist and venue approval.)</li>
                <li>Festival Merchandise: FONs branded items and collectibles (subject to availability)</li>
              </ol>

              <h4 style={{ fontSize: '16px', fontWeight: 'bold', marginTop: '15px' }}>Redemption Process</h4>
              <p>Rewards can be claimed directly through your affiliate dashboard. Redemption options, point requirements, and availability will be clearly displayed.</p>
              <ol start="7">
                <li>Processing Time: All reward redemptions will be processed within 24-48 hours of submission</li>
                <li>Restrictions: All rewards are subject to terms and conditions specific to each offering and availability. Please refer to the Program Duration section for redemption deadlines</li>
              </ol>

              <h3 style={{ fontSize: '18px', fontWeight: 'bold', marginTop: '20px' }}>5. Affiliate Leaderboard</h3>
              <p>The program features a public leaderboard visible to all affiliates, showcasing:</p>
              <ol start="9">
                <li>Top-performing affiliates ranked by Festival Points earned</li>
                <li>Performance metrics and achievements</li>
                <li>Recognition badges and milestones</li>
              </ol>
              <p>By participating in the program, you acknowledge and agree that your performance results, ranking, and username may be displayed on the public leaderboard. Personal contact information will not be shared publicly.</p>

              <h3 style={{ fontSize: '18px', fontWeight: 'bold', marginTop: '20px' }}>6. Program Terms</h3>
              <h4 style={{ fontSize: '16px', fontWeight: 'bold', marginTop: '15px' }}>Affiliate Responsibilities</h4>
              <ol start="12">
                <li>Affiliates must promote the festival honestly and ethically</li>
                <li>Misrepresentation of festival details, pricing, or offerings is strictly prohibited</li>
                <li>Spam, fraudulent activity, or manipulation of the referral system will result in immediate termination</li>
                <li>Affiliates may not use their own codes for personal purchases unless explicitly permitted</li>
              </ol>

              <h4 style={{ fontSize: '16px', fontWeight: 'bold', marginTop: '15px' }}>Program Duration</h4>
              <p>The Affiliate Program operates according to the following timeline:</p>
              <ol start="16">
                <li>Program End Date: The affiliate program will officially end on January 31st, 2025, at 11:59 PM. No new referrals will be tracked after this date</li>
                <li>Points Redemption Deadline: All accumulated Festival Points must be redeemed by 4 February, 2025, at 11:59 PM (latest)</li>
                <li>Ticket Delivery: All redeemed tickets will be processed and delivered by 5 February, 2025</li>
                <li>Festival Dates: Weekend 1: February 5-6, 2025 | Weekend 2: February 12-13, 2025</li>
              </ol>
              <p><strong>Important:</strong> All accumulated points must be redeemed by the latest 4 February 2025, at 11:59 PM, or they will expire and cannot be claimed. Redeemed tickets will be processed and delivered by February 5, 2025. Redeem early to ensure you receive your rewards before the festival begins.</p>

              <h4 style={{ fontSize: '16px', fontWeight: 'bold', marginTop: '15px' }}>Program Modifications</h4>
              <p>The organizers reserve the right to modify program terms, point allocations, reward offerings, and eligibility criteria at any time with reasonable notice. Significant changes will be communicated via email and through the affiliate dashboard.</p>

              <h4 style={{ fontSize: '16px', fontWeight: 'bold', marginTop: '15px' }}>Termination</h4>
              <p>Either party may terminate participation in the program at any time. Upon termination, accumulated points may be forfeited or redeemed based on the circumstances of termination and at the sole discretion of the program administrators.</p>

              <h3 style={{ fontSize: '18px', fontWeight: 'bold', marginTop: '20px' }}>7. Confidentiality & Data Privacy</h3>
              <h4 style={{ fontSize: '16px', fontWeight: 'bold', marginTop: '15px' }}>Confidential Information</h4>
              <p>As an affiliate, you may receive access to non-public information regarding festival operations, marketing strategies, attendance data, or promotional plans. You agree to maintain the confidentiality of such information and not disclose it to third parties without express written permission.</p>

              <h4 style={{ fontSize: '16px', fontWeight: 'bold', marginTop: '15px' }}>Data Collection & Usage</h4>
              <p>By participating in the program, you acknowledge that:</p>
              <ol start="20">
                <li>Your referral activity, performance metrics, and reward redemptions will be tracked and stored</li>
                <li>Anonymized aggregate data may be used for program analysis and improvement</li>
                <li>Your personal information will be handled in accordance with applicable data protection regulations</li>
                <li>You will not share your unique affiliate link or dashboard access credentials with unauthorized parties</li>
              </ol>

              <h3 style={{ fontSize: '18px', fontWeight: 'bold', marginTop: '20px' }}>8. Acceptance of Terms</h3>
              <p>By enrolling in the Fans Affiliate Program and utilizing your unique referral code and link, you acknowledge that you have read, understood, and agree to be bound by these Terms & Conditions. Continued participation in the program constitutes ongoing acceptance of these terms and any subsequent modifications.</p>

              <div style={{ marginTop: '30px', textAlign: 'center' }}>
                <button
                  type="button"
                  onClick={() => setIsTosPopupOpen(false)}
                  className="popup-submit-btn"
                  style={{ backgroundColor: '#ED196F', color: 'white', maxWidth: '200px' }}
                >
                  {isArabic ? 'إغلاق' : 'Close'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </Router>
  );
}
function App() {
  return (
    <LanguageProvider>
      <AppContent />
    </LanguageProvider>
  );
}

export default App;
